module.exports = __webpack_public_path__ + "static/media/blueWireTransfer19.df1fb00e.svg";